import { render } from "./CompaniesList.vue?vue&type=template&id=b421d5be&scoped=true"
import script from "./CompaniesList.vue?vue&type=script&lang=js"
export * from "./CompaniesList.vue?vue&type=script&lang=js"

import "./CompaniesList.vue?vue&type=style&index=0&id=b421d5be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b421d5be"]])

export default __exports__